<template>
    <div class="scan_container">
        <div v-show="showMsg" class="msg-container">
            <div class="content">
                <img src="../../static/images/scan_msg.png" alt="">
                <p v-html="scanMsg"></p>
            </div>
        </div>
        <div v-show="showError" class="msg-container">
            <div class="content">
                <img src="../../static/images/scan_error.png" alt="">
                <p class="err" v-html="scanMsg"></p>
            </div>
        </div>
    </div>
</template>

<script>
// import topNav from "../topnav/topnav"
import {DETAIL as API} from "@/assets/api";
import {Toast,Dialog} from 'vant';
export default {
    name: 'scan',
    components:{
        //  topNav,
    },
    data() {
        return {
            // title:"账单详情"
            showMsg:false,//显示提示信息
            showError:false,//显示异常信息
            scanMsg:"",//扫码提示
            disabledAjax:false,//禁止请求ajax请求
        }
    },
    methods:{
        getCarNum(){
        var loadinginstace=this.$toast.loading({
            mask: true,
            message: '加载中...'
            });
        var url = this.url.url + "/api/js/lastcar";
        var devid=sessionStorage.getItem("devid");
        var appid=sessionStorage.getItem("appid");
        var id=sessionStorage.getItem("id");
        //   var params = new URLSearchParams();
        //   params.append("devid", devid);
        //   params.append("appid",appid);
        //   params.append("id",id);
            var req = {
                devid: devid,
                appid: appid,
                id: id
            }
        
            this.$http({
                method: 'post',
                url: url,
                data: this.qs.stringify(req),
                success: function(result){
                    loadinginstace.clear();
                    var res = result.data;
                    if (result.code == 0) {
                        this.commonUtil.queryajax(res.vehicleno,id);
                    } else {
                        alert("没有查到车牌号");
                        if(this.commonUtil.browserType() == "wx"){
                            setTimeout(()=>{
                                if(WeixinJSBridge){
                                    WeixinJSBridge.call('closeWindow');
                                }
                            },500);
                        }else if(this.commonUtil.browserType() == "al"){
                            AlipayJSBridge.call("closeWebview");
                        }
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }.bind(this)
            })
        },
        noBodyScan(){
            
            // if(this.disabledAjax){
            //     return;
            // }else{
            //     this.disabledAjax = true;
            //     //0.5秒后才能再次请求
            //     setTimeout(()=>{
            //         this.disabledAjax = false;
            //     },500);
            // }
            var originalId = sessionStorage.getItem("originalId");
            var type = sessionStorage.getItem("type");//0为无人值守入场   1为无人值守出场
            var appid = sessionStorage.getItem("appid");
            var devid = sessionStorage.getItem("devid");
            var time = sessionStorage.getItem("time");
            var mac = sessionStorage.getItem("mac");
            var id = sessionStorage.getItem("id");
            var bowserType = this.commonUtil.browserType();
            var req = {
                originalId: originalId,
                type: type,
                appid: appid,
                devid: devid,
                time: time,
                mac: mac,
                id: id,
                bowserType: bowserType
            }
            if(type == 3){
                req.cardno = sessionStorage.getItem("cardno")
            }
            this.$http({
                method: 'post',
                url: API.NO_BODY_DUTY_SAN,
                data: this.qs.stringify(req),
                success: function(data){
                    if(type == 0 || type == 2){//无人值守 入场(type:0 无人值守入场 type：2固定码入场)
                        if(data.code == 0){
                            this.showMsg = true;
                            this.scanMsg = "该车为无牌车辆，<br>出入场请您用同一个微信号扫码或缴费离开。<br>谢谢您的理解与配合！";
                        }else{
                            alert(data.msg);
                        }
                    }else if(type == 1 || type == 3){//无人值守 出场(type:1 无人值守出场 type：3固定码出场)
                        if(data.code == 0){
                            if(data.needPay == "true"){
                                this.formatData(data)
                            }else{
                                this.showMsg = true
                                if(type == 3){
                                    this.scanMsg = "该车辆费用为0"
                                }else{
                                    this.scanMsg = "未产生费用闸门已开"
                                }
                            }
                        }else{
                            //alert(data.msg);
                            // 如果返回的等于这个 originalId 为none 但是还是要往下走
                            if(data.msg != '请使用微信支付宝浏览器'){
                                this.showError = true
                                this.scanMsg = data.msg
                            }
                        }
                    }
                }.bind(this),
                error: function(error){
                    this.showError = true;
                    this.scanMsg = '扫码异常，请重新扫码';
                    setTimeout(()=>{
                        if(this.commonUtil.browserType() == "wx"){
                            if(WeixinJSBridge){
                                WeixinJSBridge.call('closeWindow');
                            }
                        }else if(this.commonUtil.browserType() == "al"){
                            AlipayJSBridge.call("closeWebview");
                        }
                    },1500)
                }.bind(this)
            })
        },
        formatData(result){//处理无人值守接口返回数据
            if (result.code == 0) {
                if (result.resultcode == '0000') {
                    var datas = result.data;
                    var projectDo = result.projectDo;
                    var indate = datas.indate,
                        intime = datas.intime;
                    var acdate = indate.substring(0, 4) + "-" + indate.substring(4, 6) + "-" + indate.substring(6, 8);
                    var actime = intime.substring(0, 2) + ":" + intime.substring(2, 4) + ":" + intime.substring(4, 6);
                    var dateIn = acdate + " " + actime;
                    var totalMinute = datas.times % 60,
                        totalHours = Math.floor(datas.times / 60);
                    var totalTime = totalHours + "小时" + totalMinute + "分钟";
                    var totalfee = datas.lastfee;
                    sessionStorage.setItem("payfee", totalfee);
                    sessionStorage.setItem("cardno", datas.cardno);
                    var parkingname = datas.parkingname;
                    if (datas.appid) { //微信下单appid
                        sessionStorage.setItem("appid", datas.appid);
                    }
                    this.commonUtil.setCookie("parkingname", parkingname, 30)
                    this.commonUtil.setCookie("dateIn", dateIn, 30)
                    this.commonUtil.setCookie("totalTime", totalTime, 30)
                    this.commonUtil.setCookie("totalfee", datas.totalfee, 30)
                    //查询成功后将车牌号存入本地，保存30天
                    if(datas.vehicleno){
                        this.commonUtil.setCookie("carNum2", datas.vehicleno, 30)
                    }else{
                        this.commonUtil.delCookie("carNum2");
                    }
                    this.commonUtil.setCookie("inurl", datas.inurl, 30);
                    this.commonUtil.setCookie("discfee", datas.discfee, 30);
                    this.commonUtil.setCookie("freePayPermission", result.freePayPermission, 300);
                    this.commonUtil.setCookie("lastfee", datas.lastfee, 30);
                    this.commonUtil.setCookie("historyfee", datas.historyfee, 30);

                    //先清除cookie
                    this.commonUtil.delCookie("weixinPaystate");
                    this.commonUtil.delCookie("alipayPaystate");
                    this.commonUtil.delCookie("bbcPaystate");
                    this.commonUtil.delCookie("icbcPaystate");
                    this.commonUtil.delCookie("unionPaystate");
                    this.commonUtil.delCookie("ccbqrPaystate");
                    sessionStorage.setItem("payList","");
                    if (!this.commonUtil.isEmpty(projectDo)) {
                        sessionStorage.setItem("payList",JSON.stringify(projectDo))
                        for (var i = 0; i < projectDo.length; i++) {
                            if (projectDo[i] == 'WX') {
                                this.commonUtil.setCookie("weixinPaystate", "WX", 30)
                            }
                            if (projectDo[i] == "AL") {
                                this.commonUtil.setCookie("alipayPaystate", "AL", 30)
                            }
                            if (projectDo[i] == "CCB") {
                                this.commonUtil.setCookie("bbcPaystate", "CCB", 30)
                            }
                            if (projectDo[i] == "ICBC") {
                                this.commonUtil.setCookie("icbcPaystate", "ICBC", 30)
                            }
                            if (projectDo[i] == "UNION") {
                                this.commonUtil.setCookie("unionPaystate", "UNION", 30)
                            }
                            if (projectDo[i] == "CCBQR") {
                                this.commonUtil.setCookie("ccbqrPaystate", "CCBQR", 30)
                            }
                        }
                    }
                    if (totalfee == '0.00') {
                        Dialog.alert({
                        title: '提示',
                        message: '该车辆暂未产生停车费用,最终费用以车辆本次在场累计时间为准'
                        })

                    } else {
                        this.$router.push({
                            name: 'paydetail',
                            params: {
                                page: 'index',
                            }
                        });
                    }
                }
            } else if (result.code == '500') {
                Toast({
                duration: 1200,
                message: '该车辆暂未产生停车费用,最终费用以车辆本次在场累计时间为准'
                //message: '未查到车辆信息'
                });
            } else {
                Toast({
                duration: 1200,
                message: '查询信息失败'
                });
            }
        },
        fnScan(){
            if(this.commonUtil.browserType() == "wx" || this.commonUtil.browserType() == "al"){
                var Timer = null
                clearTimeout(Timer)
                var originalId = sessionStorage.getItem("originalId");
                var type = sessionStorage.getItem("type");
                    
                if(!originalId){
                    var loadinginstace=this.$toast.loading({
                        mask: true,
                        message: '查询中...'
                    });
                    Timer = setTimeout(()=>{
                        if(!sessionStorage.getItem("originalId")){
                            loadinginstace.clear()
                            this.showError = true;
                            this.scanMsg = '请求中,长时间未响应请扫码重试.';
                        }
                    },4500)
                    return
                }
                
                if(type){//扫码（无人值守）
                    if(type == 0){
                        document.title = "扫码入场";
                    }else if(type == 1){
                        document.title = "扫码出场";
                    }else if(type == 2){
                        document.title = "扫码入场";
                    }else if(type == 3){
                        document.title = "扫码出场";
                    }
                    this.noBodyScan()
                }else{//扫码（岗亭码，场内码）
                    this.getCarNum()
                }
            }else{
                this.showError = true;
                this.scanMsg = '请使用微信或支付宝扫码';
            }
        },
    },
    mounted(){
        
    },
    watch:{
        "$route":{
            handler(value,oldValue){
                this.fnScan()
            },
            deep: true,
            immediate:true
        }
    }


}
</script>
<style lang="less" scoped>
    .scan_container{
        .msg-container{
            height: 100vh;
            border-top: 1px solid transparent;
            width: 100%;
            background: rgba(0,0,0,0.5);
        }
        .msg-container .content{
            box-sizing: border-box;
            padding: 16px 8px;
            min-height: 200px;
            width: 84%;
            border-radius: 5px;
            background: #fff;
            margin: 0 auto;
            left: 50%;
            top: 50%;
            margin-left: -40%;
            margin-top: -100px;
            position: relative;
        }
        .msg-container .content img{
            width: 148px;
            height: 91px;
            margin-top: 16px;
            margin-bottom: 8px;
        }
        .msg-container .content p{
            font-size: 14px;
            color:rgb(154,154,154);
            line-height: 30px;
        }
        .msg-container .content p .warn_tips{
            font-size: 12px;
            color: red;
        }
        .msg-container .content p.err{
            color:red;
            font-weight: bold;
            opacity: 0.6;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/scan.vue